module.exports = __webpack_public_path__ + "media/home-video.9a98fa1b.mp4";